/* global process */

/**
 * Get the API domain.
 * @returns {string}
 */
export const getAPIDomain = () => {
  /** @type {string} */
  let apiDomain;

  if (typeof window !== 'undefined') {
    apiDomain = window.__CLIENT_ENV__?.API_DOMAIN ?? '';
  } else {
    apiDomain = process.env.API_DOMAIN;
  }

  if (!apiDomain) {
    throw new Error('API_DOMAIN is not defined. Please set it in your environment variables.');
  }

  return apiDomain;
};

/**
 * Get the asset domain.
 * @returns {string | undefined}
 */
export const getAssetDomain = () => {
  /** @type {string} */
  let assetDomain;

  if (typeof window !== 'undefined') {
    assetDomain = window.__CLIENT_ENV__?.ASSET_DOMAIN ?? '';
  } else {
    assetDomain = process.env.ASSET_DOMAIN;
  }

  if (!assetDomain) {
    assetDomain = '';
  }

  return assetDomain;
};

/**
 * Get the local static API usage flag.
 * @returns {boolean | undefined}
 */
export const usingLocalStaticAPI = () => {
  /** @type {boolean | undefined} */
  let useLocalStaticApi;

  if (typeof window !== 'undefined') {
    useLocalStaticApi = Boolean(window.__CLIENT_ENV__?.USING_LOCAL_STATIC_API);
  } else {
    useLocalStaticApi = Boolean(process.env.LOCAL_API_STATIC);
  }

  return useLocalStaticApi;
};

/**
 * Get the static hostname.
 * @returns {string | undefined}
 */
export const getStaticHostname = () => {
  /** @type {string | undefined} */
  let staticHostname;

  if (typeof window !== 'undefined') {
    staticHostname = window.__CLIENT_ENV__?.STATIC_HOSTNAME ?? '';
  } else {
    staticHostname = process.env.STATIC_HOSTNAME;
  }

  return staticHostname;
};

export const getEnviroment = () => {
  const environment = process.env.NODE_ENV;

  return environment;
};
